export default {
  feedback: {
    token_required: 'Please click the checkbox to verify you are a human',
  },
};
